import XLSXIntegration from "./xlsxIntegration";

export default XLSXIntegration;
